import tagList from './modules/store'

export const modules = {
  tagList
}



// WEBPACK FOOTER //
// ./src/store/Tags/index.js